<template>
<div>
</div>
</template>

<script>
  export default {
    mounted() {
      this.$bus.$emit('setFrame', null, null)

      // Initiate the event handler in App.vue
      window.top.postMessage({
        message: '3DS-authentication-complete',
        payload: this.$route.query.payment_intent_client_secret
      })
    }
  }
</script>
